import { useState } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogActions, DialogContent, Typography, IconButton } from "@mui/material";
import Loader from "../loader/Loader";
import CloseIcon from '@mui/icons-material/Close';

export interface SimpleDialogProps {
  open: boolean;
  onClose: (value: boolean) => void;
  asyncOperation?: () => Promise<boolean>;
  closeModalAfterSubmit?: boolean;
  closeSubmitModal: () => void;
  confirmMessage: string;
}  

const ConfirmModal = (props: SimpleDialogProps) => {
  const { onClose, open } = props;

  const [isOperationInProgress, setOperationInProgress] = useState(false);

  const handleClose = () => {
    onClose(false);
  };

  const _executeOperation = async () => {
    if (props.asyncOperation) {
      setOperationInProgress(true);
      const result = await props.asyncOperation();
      if (props.closeModalAfterSubmit && result) {
        props.closeSubmitModal();
      }
      setOperationInProgress(false);
    }
  };

  return (
    <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth="xs">
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          backgroundColor: "primary.main",
          color: (theme) => theme.palette.grey[50],
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Confirmation
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: (theme) => theme.palette.grey[50],
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{height:'100px', paddingTop: "10px"}}>
        <Typography variant="h6">{props.confirmMessage}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => _executeOperation()}
          size="small"
        >
          OK
        </Button>
        <Button variant="outlined" onClick={handleClose} size="small">
          Go Back
        </Button>
      </DialogActions>
      <Loader isLoading={isOperationInProgress} />
    </Dialog>
  );
};

export default ConfirmModal;
